import app from '../app';
import Modal from '../../common/components/Modal';
import Button from '../../common/components/Button';
import classList from '../../common/utils/classList';
import alertUtil from './alertUtil';

export default class RoleBindConfirmModal extends Modal {
  oninit(vnode) {
    super.oninit(vnode);
    this.onConfirm = vnode.attrs.onConfirm;
    this.confirmText = vnode.attrs.confirmText;
    this.successText = vnode.attrs.successText;
    this.loading = false;
  }

  className() {
    return 'NickameModal Modal--small dl-modal-small';
  }

  title() {
    return;
  }

  view() {
    if (this.alertAttrs) {
      this.alertAttrs.dismissible = false;
    }

    return (
      <div className={classList('Modal modal-dialog fade Modal-sign-container Modal-bind-role', this.className())}>
        <div className="Modal-sign-content">{this.content()}</div>
      </div>
    );
  }

  content() {
    return (
      <div className="Modal-sign-body">
        <div className="header">
          <div className="title">{app.translator.trans('dl-optimization.forum.roleBindConfirmModal.hint')}</div>
        </div>
        <div className="content">
          <div className="bottom">
            {this.confirmText
              ? <p>{this.confirmText}</p>
              : <p>{app.translator.trans('dl-optimization.forum.roleBindConfirmModal.sure_bind_role')}<a href="/p/bind-notice" target="_blank" style="color: #5b9bd5; text-decoration: underline;">{app.translator.trans('dl-optimization.forum.roleBindConfirmModal.binding_matters')}</a></p>
            }
          </div>
        </div>
        <div className="footer">
          <Button className="btn btn-primary" onclick={() => this.handleConfirm()} disabled={this.loading}>{app.translator.trans('dl-optimization.forum.roleBindConfirmModal.operation.sure')}</Button>
          <Button className="btn" onclick={() => app.modal.close()}>{app.translator.trans('dl-optimization.forum.roleBindConfirmModal.operation.cancel')}</Button>
        </div>
      </div>
    );
  }

  handleConfirm() {
    this.loading = true;
    if (this.onConfirm) {
      this.onConfirm()
        .then((res) => {
          this.loading = false;
          if (this.successText) {
            alertUtil.onSuccess(app, this.successText);
          } else if (res && res.firstBind) {
            // alertUtil.onSuccess(app, app.translator.trans('dl-optimization.forum.roleBindConfirmModal.bind_success'));
          } else {
            alertUtil.onSuccess(app, app.translator.trans('dl-optimization.forum.roleBindConfirmModal.bind_change_success'));
          }
          app.modal.close();
        })
        .catch(() => {
          this.loading = false;
        });
    }
  }
}
